import React from 'react';
import styled from 'styled-components';
import { Link, NavLink as RouterNavLink } from 'react-router-dom';
import logo from '../../assets/logo.png';

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TopHeader = styled.header`
  background: #000;
  padding: 0.5rem 2rem;
  display: flex;
  align-items: center;
`;

const LogoLink = styled.a`
  display: flex;
  align-items: center;
  margin-right: 2rem;
`;

const LogoImage = styled.img`
  height: 24px;
  width: auto;
`;

const TopNavigation = styled.nav`
  display: flex;
  align-items: center;
`;

const TopNavLink = styled.a`
  color: #fff;
  text-decoration: none;
  font-size: 0.9rem;
  margin-left: 2rem;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
`;

const MainHeader = styled.header`
  background: #fff;
  padding: 1rem 2rem;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.border.light};
`;

const Logo = styled(Link)`
  color: #000;
  text-decoration: none;
  font-size: 2rem;
  font-weight: bold;
  margin-right: 3rem;
`;

const MainNavigation = styled.nav`
  display: flex;
  gap: 2rem;
  align-items: center;
`;

const MainNavLink = styled(RouterNavLink)`
  color: #000;
  text-decoration: none;
  font-size: 1rem;
  transition: opacity 0.2s;
  padding: 0.5rem 1rem;

  &.active {
    font-weight: bold;
  }

  &:hover {
    opacity: 0.7;
  }
`;

const Header = () => {
  return (
    <HeaderWrapper>
      <TopHeader>
        <LogoLink href="https://radiolize.com">
          <LogoImage src={logo} alt="Logo" />
        </LogoLink>
        <TopNavigation>
          <TopNavLink href="https://broadcaster.radiolize.com">Broadcaster</TopNavLink>
        </TopNavigation>
      </TopHeader>
      <MainHeader>
        <Logo to="/player">Radio Widget Builder</Logo>
        <MainNavigation>
          <MainNavLink to="/player">Player</MainNavLink>
          <MainNavLink to="/song-history">Song History</MainNavLink>
        </MainNavigation>
      </MainHeader>
    </HeaderWrapper>
  );
};

export default Header; 